import { createContext, useContext } from "react";
import { useImmerReducer } from "use-immer";

const initSelectedDash = {
    selectedDashboardId: null,
    selectedDashboardHash: null,
    layoutNode: null
};

function reducer(draft, { type, payload }) {
    switch (type) {
      case "setSelectedDashboardId": {
        draft.selectedDashboardId = payload;
        break;
      }
      case "setSelectedDashboardHash": {
        draft.selectedDashboardHash = payload;
        break;
      }
      case "setLayoutNode": {
        draft.layoutNode = payload;
        break;
      }
      default: {
        return null;
      }
    }
}

const [SelectedDashboardContext, SelectedDashboardDispatchContext] = [
    createContext(null),
    createContext(null),
  ];
  
  export default function SelectedDashboardProvider({ init, children }) {
    const [store, dispatch] = useImmerReducer(
      reducer,
      init || initSelectedDash
    );
  
    return (
      <SelectedDashboardContext.Provider value={store}>
        <SelectedDashboardDispatchContext.Provider value={dispatch}>
          {children}
        </SelectedDashboardDispatchContext.Provider>
      </SelectedDashboardContext.Provider>
    );
  }
  
  export function useSelectedDashboardStore() {
    return useContext(SelectedDashboardContext);
  }
  
  export function useSelectedDashboardDispatch() {
    return useContext(SelectedDashboardDispatchContext);
  }